import { render, staticRenderFns } from "./Ebook.vue?vue&type=template&id=4f9c2ec0&scoped=true&"
import script from "./Ebook.vue?vue&type=script&lang=js&"
export * from "./Ebook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f9c2ec0",
  null
  
)

export default component.exports